<div echarts [id]="chartId" [options]="options" class="chart-container"></div>
<div class="content-chart">
    <span class="presentage-value">
        {{data.value}}%
    </span>
    <span class="chart-title">
        {{data.title}}
    </span>
</div>
